// extracted by mini-css-extract-plugin
module.exports = {"homepageContainer":"index-module--homepageContainer--2DAOX","companiesTitle":"index-module--companiesTitle--V2vVq"};